// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"41c5d309","424":"78110575"}[chunkId] + ".chunk.js";
};